"use client"

// src/input.tsx
import {
  forwardRef,
  omitThemeProps,
  ui,
  useComponentMultiStyle
} from "@yamada-ui/core";
import { useFormControlProps } from "@yamada-ui/form-control";
import { cx } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var Input = forwardRef((props, ref) => {
  const [styles, mergedProps] = useComponentMultiStyle("Input", props);
  const computedProps = omitThemeProps(mergedProps);
  const { className, htmlSize, __css, ...rest } = useFormControlProps(computedProps);
  const css = { ...styles.field, ...__css };
  return /* @__PURE__ */ jsx(
    ui.input,
    {
      ref,
      className: cx("ui-input", className),
      size: htmlSize,
      __css: css,
      ...rest
    }
  );
});
Input.displayName = "Input";
Input.__ui__ = "Input";

export {
  Input
};
//# sourceMappingURL=chunk-2SDIXUVN.mjs.map